import { FragmentChunk } from '../../fragments/types';

export const chunkHelpers = {
  addChunk<C extends FragmentChunk>(chunks: C[], chunk: C, _index?: number): C[] {
    const index = typeof _index === 'undefined' ? chunks.length : _index;
    return [...chunks.slice(0, index), chunk, ...chunks.slice(index)];
  },

  moveChunkLeft<C extends FragmentChunk>(chunks: C[], chunk: C): C[] {
    const index = chunks.findIndex((c) => c === chunk);

    if (index === 0) {
      return chunks;
    }

    const clone = chunks.slice();

    clone[index] = clone[index - 1];
    clone[index - 1] = chunk;

    return clone;
  },

  moveChunkRight<C extends FragmentChunk>(chunks: C[], chunk: C): C[] {
    const index = chunks.findIndex((c) => c === chunk);

    if (index === chunks.length - 1) {
      return chunks;
    }

    const clone = chunks.slice();

    clone[index] = clone[index + 1];
    clone[index + 1] = chunk;

    return clone;
  },

  removeChunk<C extends FragmentChunk>(chunks: C[], chunk: C): C[] {
    return chunkHelpers.removeChunkByIndex(
      chunks,
      chunks.findIndex((c) => c === chunk),
    );
  },

  removeChunkByIndex<C extends FragmentChunk>(chunks: C[], index: number): C[] {
    return [...chunks.slice(0, index), ...chunks.slice(index + 1)];
  },
};
